import axios from '../utils/axios'
import qs from "qs"

// 可填写报表列表
export function listForm(params) {
  return axios.get('/api/form/list.do', {params});
}
// 可填报表单详情
export function listFieldForm(params) {
  return axios.get('/api/form/field/list.do?fid=' + params.fid);
}
// 添加表单
export function addForm(params) {
  return axios.post('/api/form/field/data/add.do', params);
}
// 修改表单 
export function editForm(params) {
  return axios.post('/api/form/field/data/edit.do', params);
}

// 可填报表单详情
export function infoFieldForm(params) {
  return axios.get('/api/form/field/data/info.do?fid=' + params.fid);
}

// 可填报表单详情
export function getByFormIdInfo(params) {
  return axios.get('api/form/field/data/list.do', {params});
}

// 审核相关
// 管理员审核列表
export function getAuditList(params) {
  return axios.get('/api/form/data/list.do', { params });
}

// 提交审核数据 
export function setAuditData(params) {
  return axios.post('/api/form/field/data/audit.do', params);
}

// 通讯录
export function getBook(params) {
  return axios.post('/api/form/address/book/list.do', qs.stringify(params));
}

export function getHtml(url) {
  return axios.get(url);
}

// /api/form/user/submit/data.do
export function getsubmitData(params) {
  console.log('params-->', params)
  const {isOutside = false} = params
  // 判断是否是校外社区表单，校外单独接口
  if(isOutside) {
    return axios.get('/api/outsideorg/form/info.do', { params });
  } else {
    return axios.get('/api/form/user/submit/data.do', { params });
  }
}

// /api/form/counselor/profile.do
export function getCounselorData(params) {
  return axios.get('/api/form/counselor/profile.do', { params });
}

// 删除当前用户填报数据
export function delForm(params) {
  return axios.post('/api/form/field/data/del.do', qs.stringify(params));
}

// 搜索大学列表
export function getCollegeListForm(params) {
  return axios.get('api/highschool/search.do?keywords=' + params.key);
}
